// Função para obter os parâmetros UTM da URL e armazená-los no localStorage
function storeUTMParams() {
    const urlParams = new URLSearchParams(window.location.search);
    const utmParams = {};
    // Adiciona os parâmetros UTM ao objeto
    ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'].forEach(param => {
        if (urlParams.has(param)) {
            utmParams[param] = urlParams.get(param);
        }
    });
    // Armazena os parâmetros no localStorage
    if (Object.keys(utmParams).length > 0) {
        localStorage.setItem('utmParams', JSON.stringify(utmParams));
    }
}

// Função para adicionar os parâmetros UTM aos links internos
function appendUTMToLinks() {
    const utmParams = JSON.parse(localStorage.getItem('utmParams'));
    if (utmParams) {
        const links = document.querySelectorAll('a'); // Seleciona todos os links no site
        links.forEach(link => {
            let href = link.getAttribute('href');
            if (href && !href.includes('utm_')) { // Só adiciona os UTM's aos links sem parâmetros UTM
                const separator = href.includes('?') ? '&' : '?';
                const utmString = Object.keys(utmParams)
                    .map(key => `${key}=${utmParams[key]}`)
                    .join('&');
                link.setAttribute('href', href + separator + utmString);
            }
        });
    }
}

// Chama a função para armazenar os parâmetros UTM quando a página é carregada
storeUTMParams();

// Chama a função para adicionar os parâmetros UTM aos links
document.addEventListener("DOMContentLoaded", function() {
    appendUTMToLinks();
});
